/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RetryInputs */

const en_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const ar_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حاول مجدداً`)
};

const de_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const es_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inténtalo de nuevo`)
};

const fr_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const it_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

const ja_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再度試す`)
};

const ko_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도하세요`)
};

const pt_br_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente novamente`)
};

const ru_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте еще раз`)
};

const th_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองอีกครั้ง`)
};

const tr_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar dene`)
};

const zh_cn_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const zh_tw_retry = /** @type {(inputs: RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重試`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {RetryInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const retry = /** @type {((inputs?: RetryInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RetryInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_retry(inputs)
	if (locale === "ar") return ar_retry(inputs)
	if (locale === "de") return de_retry(inputs)
	if (locale === "es") return es_retry(inputs)
	if (locale === "fr") return fr_retry(inputs)
	if (locale === "it") return it_retry(inputs)
	if (locale === "ja") return ja_retry(inputs)
	if (locale === "ko") return ko_retry(inputs)
	if (locale === "pt_br") return pt_br_retry(inputs)
	if (locale === "ru") return ru_retry(inputs)
	if (locale === "th") return th_retry(inputs)
	if (locale === "tr") return tr_retry(inputs)
	if (locale === "zh_cn") return zh_cn_retry(inputs)
	return zh_tw_retry(inputs)
});